import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// استيراد ملفات الترجمة المحلية
import translationAR from './locales/ar/translation.json';
import translationEN from './locales/en/translation.json';
import translationFR from './locales/fr/translation.json';

const resources = {
  ar: { translation: translationAR },
  en: { translation: translationEN },
  fr: { translation: translationFR },
};

// لا تستخدم LanguageDetector أو HTTP backend هنا.
// سنعتمد على تغيير اللغة من index.js بعد قراءة اللغة من الـ DB.
i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'en',           // قيمة افتراضية مؤقتة — سيتم استبدالها عند init() في index.js
    fallbackLng: 'en',
    interpolation: { escapeValue: false },
    react: { useSuspense: false }
  });

const applyDirection = (lang) => {
  const dir = lang === 'ar' ? 'rtl' : 'ltr';
  document.documentElement.setAttribute('dir', dir);
  document.documentElement.setAttribute('lang', lang || 'en');
};

applyDirection(i18n.language);
i18n.on('languageChanged', applyDirection);

export default i18n;
